<template>
  <v-container fluid class="auth-wrapper pa-0">
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="auth-card pa-8" elevation="0">

          <div class="text-center mb-6">
            <h1 class="brand-title">Cargas<span style="color:#16b37c">Zap</span></h1>
            <p class="subtitle">Criar nova conta</p>
          </div>

          <v-form
            v-model="valid"
            autocomplete="off"
            :key="'form-' + formKey"
          >

            <!-- Anti autofill real -->
            <input type="text" name="fakeuser" style="display:none">
            <input type="password" name="fakepass" style="display:none">

            <!-- Nome -->
            <v-text-field
              v-model="name"
              label="Nome completo"
              prepend-inner-icon="mdi-account-outline"
              :rules="nameRules"
              outlined
              dense
              dark
              autocomplete="new-name"
              class="mb-0"
            />

            <!-- Email -->
            <v-text-field
              v-model="email"
              label="E-mail"
              prepend-inner-icon="mdi-email-outline"
              :rules="emailRules"
              outlined
              dense
              dark
              autocomplete="new-email"
              class="mb-0"
            />

            <!-- Senha -->
            <v-text-field
              v-model="password"
              label="Senha"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'"
              :rules="passwordRules"
              outlined
              dense
              dark
              autocomplete="new-password"
              class="mb-0"
              @click:append="showPassword = !showPassword"
            />

            <!-- Confirmar senha -->
            <v-text-field
              v-model="confirmPassword"
              label="Confirmar senha"
              prepend-inner-icon="mdi-lock-check-outline"
              :append-icon="showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showConfirmPassword ? 'text' : 'password'"
              :rules="confirmPasswordRules"
              outlined
              dense
              dark
              autocomplete="new-password"
              class="mb-0"
              @click:append="showConfirmPassword = !showConfirmPassword"
            />

            <!-- Termos -->
            <div class="termos-wrap mb-4">
              <v-checkbox
                v-model="aceitaTermos"
                hide-details
                dense
                dark
                class="termos-check mt-0 pt-0"
              >
                <template #label>
                  <span class="termos-text">
                    Li e concordo com os
                    <router-link to="/termos-de-uso" class="termos-link" @click.native.stop>
                      Termos de Serviço
                    </router-link>
                  </span>
                </template>
              </v-checkbox>
            </div>

            <!-- Botão -->
            <v-btn
              block
              large
              depressed
              dark
              class="primary-btn mb-4"
              :loading="loading"
              :disabled="!aceitaTermos"
              @click="register"
            >
              Criar conta
            </v-btn>

            <!-- Divisor -->
            <div class="divider">
              <span>ou</span>
            </div>

            <!-- Google -->
            <div class="google-btn mt-4 mb-4" id="google-signin-btn"></div>

          </v-form>

          <div class="text-center">
            <router-link to="/login" class="auth-link">
              Já tem conta? Entrar
            </router-link>
          </div>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RegisterPage",

  data() {
    return {
      valid: false,
      loading: false,
      formKey: Date.now(),

      showPassword: false,
      showConfirmPassword: false,
      aceitaTermos: false,

      name: "",
      email: "",
      password: "",
      confirmPassword: "",

      nameRules: [
        v => !!v || "Nome obrigatório"
      ],

      emailRules: [
        v => !!v || "E-mail obrigatório",
        v => /.+@.+\..+/.test(v) || "E-mail inválido"
      ],

      passwordRules: [
        v => !!v || "Senha obrigatória",
        v => v.length >= 6 || "Mínimo 6 caracteres"
      ],

      confirmPasswordRules: [
        v => !!v || "Confirme sua senha",
        v => v === this.password || "As senhas não coincidem"
      ]
    };
  },

  mounted() {
    // Renderiza o botão oficial do Google
    // eslint-disable-next-line no-undef
    google.accounts.id.initialize({
      client_id: '165786893140-rrhev66adkeek95lrinf7fqjurda7ma2.apps.googleusercontent.com',
      callback: this.handleCredentialResponse
    });
    // eslint-disable-next-line no-undef
    google.accounts.id.renderButton(
      document.getElementById('google-signin-btn'),
      { theme: 'outline', size: 'large', width: 350 }
    );
  },

  methods: {
    cadastroIndisponivel() {
      this.$toasted.show('Nao estamos aceitando mais cadastros no momento.', { type: 'error' });
      return true;
    },

    async register() {
      if (this.cadastroIndisponivel()) return;

      if (!this.valid) return;
      this.loading = true;
      try {
        const { registerUser, loginUser } = await import('./loginServices');
        const { default: authService } = await import('../../services/auth');

        await registerUser({ nome: this.name, email: this.email, senha: this.password });

        const { data } = await loginUser({ email: this.email, senha: this.password });

        authService.setToken(data.token);
        this.$store.commit('auth/setToken', data.token);
        this.$store.commit('auth/setUser', data.user);

        const redirectPath = this.$route.query.redirect || '/inicio';
        this.$router.push(redirectPath);
        this.$toasted.show('Cadastro realizado e login efetuado!', { type: 'success' });
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao cadastrar usuário';
        this.$toasted.show(msg, { type: 'error' });
      } finally {
        this.loading = false;
      }
    },

    async handleCredentialResponse(response) {
      if (this.cadastroIndisponivel()) return;

      this.loading = true;
      try {
        const base64Url = response.credential.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        const profile = JSON.parse(jsonPayload);
        const payload = {
          nome: profile.name,
          email: profile.email,
          google_id: profile.sub
        };
        const { registerUserGoogle, loginUserGoogle } = await import('./loginGoogleService');
        const { default: authService } = await import('../../services/auth');

        await registerUserGoogle(payload);

        const { data } = await loginUserGoogle({ google_id: payload.google_id, email: payload.email });

        authService.setToken(data.token);
        this.$store.commit('auth/setToken', data.token);
        this.$store.commit('auth/setUser', data.user);

        const redirectPath = this.$route.query.redirect || '/inicio';
        this.$router.push(redirectPath);
        this.$toasted.show('Cadastro Google realizado e login efetuado!', { type: 'success' });
      } catch (err) {
        let msg = err.response?.data?.error || 'Erro ao cadastrar com Google';
        if (msg === 'E-mail já cadastrado.') {
          msg = 'Este e-mail já está cadastrado. Tente fazer login.';
        }
        this.$toasted.show(msg, { type: 'error' });
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>

/* ===================== */
/* FUNDO */
/* ===================== */

.auth-wrapper {
  min-height: 100vh;
  background: #0b1220;
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
}

/* ===================== */
/* CARD */
/* ===================== */

.auth-card {
  width: 100%;
  max-width: 420px;
  background: #0f172a;
  border-radius: 18px;
  border: 1px solid #1f2937;
  box-shadow: 0 25px 70px rgba(0,0,0,0.55);
}

/* ===================== */
/* TEXTOS */
/* ===================== */

.brand-title {
  font-size: 1.7rem;
  font-weight: 700;
  color: #ffffff;
}

.subtitle {
  color: #94a3b8;
  font-size: 0.9rem;
}

/* ===================== */
/* INPUTS */
/* ===================== */

::v-deep .v-text-field--outlined .v-input__control {
  background: #111827;
  border-radius: 12px;
}

::v-deep .v-text-field--outlined fieldset {
  border-color: #1f2937;
  transition: 0.2s ease;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #11b981;
  box-shadow: 0 0 0 3px rgba(17,185,129,0.15);
}

::v-deep input {
  color: #e5e7eb !important;
}

::v-deep .v-label {
  color: #94a3b8 !important;
}

::v-deep .error--text {
  color: #f43f5e !important;
}

/* Remove autofill branco Chrome */
::v-deep input:-webkit-autofill,
::v-deep input:-webkit-autofill:hover,
::v-deep input:-webkit-autofill:focus,
::v-deep textarea:-webkit-autofill,
::v-deep select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #111827 inset !important;
  box-shadow: 0 0 0 1000px #111827 inset !important;
  -webkit-text-fill-color: #e5e7eb !important;
  caret-color: #e5e7eb;
  transition: background-color 9999s ease-in-out 0s;
}

/* ===================== */
/* BOTÃO PRINCIPAL */
/* ===================== */

.primary-btn {
  background-color: #11b981 !important;
  color: #ffffff !important;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  transition: 0.2s ease;
}

.primary-btn:hover {
  background-color: #0ea371 !important;
}


/* ===================== */
/* DIVISOR */
/* ===================== */

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #64748b;
  font-size: 0.8rem;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #1f2937;
}

.divider span {
  padding: 0 10px;
}

/* ===================== */
/* LINK */
/* ===================== */

.auth-link {
  color: #11b981;
  font-weight: 500;
  text-decoration: none;
}

.auth-link:hover {
  color: #0ea371;
}

/* ===================== */
/* TERMOS */
/* ===================== */

.termos-wrap {
  padding: 4px 2px;
}

.termos-text {
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.4;
}

.termos-link {
  color: #11b981;
  font-weight: 500;
  text-decoration: none;
}

.termos-link:hover {
  color: #0ea371;
}

::v-deep .termos-check .v-input__slot {
  align-items: flex-start;
}

::v-deep .termos-check .v-icon {
  color: #11b981 !important;
}

</style>
